import { TOOLTIP_VISIBLE, TOOLTIP_CURRENT_ID, TOOLTIP_CURRENT_STEP, TOOLTIP_GUIDANCE_ENABLED } from "./constants";

export default {
  [TOOLTIP_VISIBLE]: (state: any): boolean => state.tooltips.active,
  [TOOLTIP_CURRENT_ID]: (state: any): string | null => state.tooltips.currentTooltipId,
  [TOOLTIP_CURRENT_STEP]: (state: any): number => state.tooltips.currentStep,
  [TOOLTIP_GUIDANCE_ENABLED]: (state: any): boolean => state.tooltips.showGuidance,

  // Computed getters
  currentTooltipConfig: (state: any, _: any, rootState: any): any => {
    if (!state.tooltips.currentTooltipId) return null;
    
    // Find the config from available configs
    return state.availableConfigs.find((config: any) => config.id === state.tooltips.currentTooltipId) || null;
  },

  currentTooltipStep: (state: any): any => {
    if (!state.tooltips.currentTooltipId || state.tooltips.currentStep < 0) return null;
    
    const targetConfig = state.availableConfigs.find((config: any) => config.id === state.tooltips.currentTooltipId);
    return targetConfig ? targetConfig.steps[state.tooltips.currentStep] : null;
  },

  isFirstRun: (state: any): boolean => state.userPreferences.firstRun,
  
  completedTours: (state: any): string[] => state.userPreferences.completedTours,
  
  dismissedTooltips: (state: any): string[] => state.userPreferences.dismissedTooltips,

  // Check if specific tooltip is completed
  isTooltipCompleted: (state: any) => (tooltipId: string): boolean => {
    return state.userPreferences.completedTours.includes(tooltipId);
  },

  // Check if specific tooltip is dismissed
  isTooltipDismissed: (state: any) => (tooltipId: string): boolean => {
    return state.userPreferences.dismissedTooltips.includes(tooltipId);
  },

  // Get tooltip progress percentage
  tooltipProgress: (state: any): number => {
    if (!state.tooltips.currentTooltipId) return 0;
    
    const progressConfig = state.availableConfigs.find((config: any) => config.id === state.tooltips.currentTooltipId);
    if (!progressConfig) return 0;
    
    return Math.round(((state.tooltips.currentStep + 1) / progressConfig.steps.length) * 100);
  },


  // Check if current tooltip has next step
  hasNextStep: (state: any): boolean => {
    if (!state.tooltips.currentTooltipId) return false;
    
    const nextConfig = state.availableConfigs.find((config: any) => config.id === state.tooltips.currentTooltipId);
    if (!nextConfig) return false;
    
    return state.tooltips.currentStep < nextConfig.steps.length - 1;
  },

  // Check if current tooltip has previous step
  hasPreviousStep: (state: any): boolean => {
    return state.tooltips.currentStep > 0;
  },

  // Get total steps for current tooltip
  totalSteps: (state: any): number => {
    if (!state.tooltips.currentTooltipId) return 0;
    
    const stepsConfig = state.availableConfigs.find((config: any) => config.id === state.tooltips.currentTooltipId);
    return stepsConfig ? stepsConfig.steps.length : 0;
  },


  // Get current step number (1-based)
  currentStepNumber: (state: any): number => {
    return state.tooltips.currentStep + 1;
  }
};